import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
    AuctionBuilderDatesErrorCode,
    AuctionDataField,
    auctionSelectorNonNullable,
    BiddingStrategy,
    clearAuctionErrors,
    setErrors,
} from 'store/models/auctionData';
import { useSelector } from 'store/utils';

type ValidateDateFn = (date: string | null, key: AuctionDataField.StartAt | AuctionDataField.EndAt) => boolean;

export const getDateValidationError = (
    date: string | null,
    biddingStrategy: BiddingStrategy
): AuctionBuilderDatesErrorCode | false => {
    if (biddingStrategy === BiddingStrategy.Auto && !date) {
        return AuctionBuilderDatesErrorCode.ValueMissingForStrategy;
    }
    return false;
};

export const useAuctionDateValidation = (): ValidateDateFn => {
    const biddingStrategy = useSelector(auctionSelectorNonNullable.biddingStrategy);
    const dispatch = useDispatch();

    return useCallback<ValidateDateFn>(
        (date: string | null, key: AuctionDataField.StartAt | AuctionDataField.EndAt) => {
            const errorCode = getDateValidationError(date, biddingStrategy);

            if (errorCode) {
                dispatch(setErrors({ [key]: errorCode }));
                return false;
            }
            dispatch(clearAuctionErrors(key));
            return true;
        },
        [biddingStrategy, dispatch]
    );
};
